import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useNavigate } from 'react-router-dom';
import { personalDataStepFormValidationSchema } from './PersonalDataStep.config';
import { useAppDispatch, useAppSelector } from 'store/store.hooks';
import { selectRegistrationStep, setValues } from 'store/slices/registration';
import { useRedirectIfPrevFormIsNotCompleted } from 'Layout/Registration/registration.hooks';

export const usePersonalDataStepForm = () => {
  /*********************************************************
   *                      STORE HOOKS                      *
   ********************************************************/
  const personalDataStep = useAppSelector(
    selectRegistrationStep('personalDataStep'),
  );
  const dispatch = useAppDispatch();
  /*********************************************************
   *                     UTILITY HOOKS                     *
   ********************************************************/
  const navigate = useNavigate();
  /*********************************************************
   *                     FORM CONFIGS                      *
   ********************************************************/
  const methods = useForm({
    defaultValues: personalDataStep.formValues,
    resolver: zodResolver(personalDataStepFormValidationSchema),
    mode: 'onChange',
  });
  /*********************************************************
   *                   FORM SUBMIT HANDLER                 *
   ********************************************************/
  const handleSubmit = methods.handleSubmit(async function (data) {
    dispatch(
      setValues({
        type: 'SET_PERSONAL_DATA_VALUES',
        formValues: data,
      }),
    );
    navigate(personalDataStep.nextStep);
  });
  /*********************************************************
   *                        EFFECTS                        *
   ********************************************************/
  useRedirectIfPrevFormIsNotCompleted('contactDataStep');

  return { methods, personalDataStep, handleSubmit };
};
